import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useAuth, API } from '../contexts/AuthContext';

// Modulo Land — pagina 1 e o CADASTRO das lands (tabela com nome, link, prazo, ativa).
// Cada linha tem as acoes de produzir o conteudo: Subir (.html/.zip), Editor e IA.
// Aba "Configurar IA": Gemini (gratuito/pago), Anthropic (Claude) e OpenAI (1 ativa por vez).

const ROXO = '#6B2C5C';

const PROVIDERS_META = [
  {
    key: 'anthropic', nome: 'Anthropic (Claude)', plano: 'Pago',
    console: 'https://console.anthropic.com', consoleLabel: 'Abrir console.anthropic.com',
    chaveDica: 'API key sk-ant-...',
    modelos: [
      { id: 'claude-sonnet-4-6', label: 'Claude Sonnet 4.6 (equilibrado — recomendado)' },
      { id: 'claude-haiku-4-5', label: 'Claude Haiku 4.5 (mais barato/rápido)' },
      { id: 'claude-opus-4-8', label: 'Claude Opus 4.8 (mais inteligente)' },
    ],
    tutorial: [
      'Acesse console.anthropic.com e faça login.',
      'Settings → API Keys → "Create Key".',
      'Copie a chave (sk-ant-...) e cole ao lado.',
      'Em Billing, adicione créditos.',
    ],
    recomendacao: 'Recomendado pra vender — Claude Sonnet negocia e usa as ferramentas muito bem.',
  },
  {
    key: 'openai', nome: 'OpenAI (GPT)', plano: 'Pago',
    console: 'https://platform.openai.com/api-keys', consoleLabel: 'Abrir platform.openai.com',
    chaveDica: 'API key sk-...',
    modelos: [
      { id: 'gpt-4o', label: 'GPT-4o (equilibrado)' },
      { id: 'gpt-4o-mini', label: 'GPT-4o mini (mais barato/rápido)' },
    ],
    tutorial: [
      'Acesse platform.openai.com e faça login.',
      'Menu → API keys → "Create new secret key".',
      'Copie a chave (sk-...) e cole ao lado.',
      'Em Billing, adicione créditos / cartão.',
    ],
    recomendacao: 'Estável e conhecido. GPT-4o gera HTML bem-acabado.',
  },
  {
    key: 'gemini_free', nome: 'Google Gemini', plano: 'Gratuito',
    console: 'https://aistudio.google.com/app/apikey', consoleLabel: 'Abrir Google AI Studio',
    chaveDica: 'Chave do Google AI Studio',
    modelos: [
      { id: 'gemini-2.0-flash', label: 'Gemini 2.0 Flash (rápido, grátis)' },
      { id: 'gemini-1.5-flash', label: 'Gemini 1.5 Flash (grátis)' },
    ],
    tutorial: [
      'Acesse aistudio.google.com e faça login com a conta Google.',
      'Clique em "Get API key" → "Create API key".',
      'Copie a chave e cole ao lado.',
      'O plano gratuito tem limite de uso por minuto/dia.',
    ],
    recomendacao: 'Bom pra testar sem custo. Pode bater no limite de cota em horário de pico.',
  },
  {
    key: 'gemini_paid', nome: 'Google Gemini', plano: 'Pago',
    console: 'https://aistudio.google.com/app/apikey', consoleLabel: 'Abrir Google AI Studio',
    chaveDica: 'Chave do Google AI (billing ativo)',
    modelos: [
      { id: 'gemini-2.5-pro', label: 'Gemini 2.5 Pro (mais capaz)' },
      { id: 'gemini-2.0-flash', label: 'Gemini 2.0 Flash (rápido)' },
      { id: 'gemini-1.5-pro', label: 'Gemini 1.5 Pro' },
    ],
    tutorial: [
      'Acesse aistudio.google.com e faça login.',
      'Ative o faturamento (Billing) no projeto Google Cloud.',
      'Crie a API key em "Get API key" e cole ao lado.',
      'Sem o limite do plano grátis; paga por uso.',
    ],
    recomendacao: 'Mais cota e o Gemini 2.5 Pro. Bom custo-benefício.',
  },
];
function metaProvider(key) { return PROVIDERS_META.find((m) => m.key === key) || PROVIDERS_META[0]; }

const ORIGEM_LABEL = { upload: 'Upload', editor: 'Editor', ia: 'IA' };
const MODO_LABEL = { upload: 'Subir', editor: 'Editor', ia: 'IA' };

// Mesma geração de QR Code usada na Torcida Centrão (api.qrserver.com).
const qrUrl = (link) => `https://api.qrserver.com/v1/create-qr-code/?size=220x220&margin=8&data=${encodeURIComponent(link)}`;

function paraInputDateTime(val) {
  // O backend grava/serve datas naive; basta cortar os 16 primeiros chars (YYYY-MM-DDTHH:MM).
  return val ? String(val).slice(0, 16) : '';
}
function fmtData(val) {
  if (!val) return null;
  const s = String(val).slice(0, 16);
  const [d, h] = s.split('T');
  if (!d) return null;
  const [a, m, dia] = d.split('-');
  return `${dia}/${m}/${a}${h ? ' ' + h : ''}`;
}
function fmtPrazo(di, df) {
  const a = fmtData(di);
  const b = fmtData(df);
  if (!a && !b) return <span className="text-muted">sem prazo</span>;
  return <span>{a || '…'} <i className="bi bi-arrow-right mx-1" /> {b || '…'}</span>;
}

const HTML_EXEMPLO = `<!DOCTYPE html>
<html lang="pt-br">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <title>Minha Campanha</title>
  <style>
    body { margin:0; font-family:system-ui,Arial,sans-serif; color:#2D1427; }
    .hero { background:#6B2C5C; color:#fff; padding:64px 24px; text-align:center; }
    .hero h1 { font-size:34px; margin:0 0 12px; }
    .cta { display:inline-block; margin-top:20px; background:#fff; color:#6B2C5C;
           padding:12px 28px; border-radius:999px; font-weight:bold; text-decoration:none; }
  </style>
</head>
<body>
  <section class="hero">
    <h1>Campanha Centrão</h1>
    <p>Ofertas imperdíveis em materiais de construção.</p>
    <a class="cta" href="#">Quero aproveitar</a>
  </section>
</body>
</html>`;

export default function Land() {
  const { temPermissao } = useAuth();
  const podeGerenciar = temPermissao('land_gerenciar');

  const [aba, setAba] = useState('lista'); // lista | config
  const [lista, setLista] = useState([]);
  const [carregando, setCarregando] = useState(true);

  const [cadastro, setCadastro] = useState(null); // modal de DADOS da land
  const [salvandoCad, setSalvandoCad] = useState(false);

  const [edit, setEdit] = useState(null); // editor de CONTEUDO { id, nome, slug, status, html, modo }
  const [salvando, setSalvando] = useState(false);
  const [promptIa, setPromptIa] = useState('');
  const [gerandoIa, setGerandoIa] = useState(false);

  const [configIa, setConfigIa] = useState([]);

  const carregarLista = useCallback(() => {
    setCarregando(true);
    axios.get(`${API}/land`).then((r) => setLista(r.data)).catch(() => setLista([])).finally(() => setCarregando(false));
  }, []);
  const carregarConfig = useCallback(() => {
    if (!podeGerenciar) return;
    axios.get(`${API}/land/ia/config`).then((r) => setConfigIa(r.data)).catch(() => setConfigIa([]));
  }, [podeGerenciar]);

  useEffect(() => { carregarLista(); }, [carregarLista]);
  useEffect(() => { if (aba === 'config') carregarConfig(); }, [aba, carregarConfig]);

  const erro = (msg) => Swal.fire({ icon: 'error', title: 'Ops', text: msg, confirmButtonColor: ROXO });
  const ok = (msg) => Swal.fire({ icon: 'success', title: 'Pronto', text: msg, timer: 1600, showConfirmButton: false });

  // ---------------- CADASTRO (dados da land) ----------------
  function novaLand() {
    setCadastro({ nome: '', slug: '', data_inicio: '', data_fim: '', ativa: false, offline_titulo: '', offline_msg: '' });
  }
  async function editarDados(id) {
    try {
      const r = await axios.get(`${API}/land/${id}`);
      const lp = r.data;
      setCadastro({
        id: lp.id, nome: lp.nome, slug: lp.slug,
        data_inicio: paraInputDateTime(lp.data_inicio), data_fim: paraInputDateTime(lp.data_fim),
        ativa: lp.status === 'publicada', offline_titulo: lp.offline_titulo || '', offline_msg: lp.offline_msg || '',
      });
    } catch (e) { erro('Não foi possível abrir os dados.'); }
  }
  async function salvarCadastro() {
    if (!cadastro.nome.trim()) return erro('Informe o nome da land.');
    setSalvandoCad(true);
    try {
      const corpo = {
        nome: cadastro.nome, slug: cadastro.slug, ativa: cadastro.ativa,
        data_inicio: cadastro.data_inicio, data_fim: cadastro.data_fim,
        offline_titulo: cadastro.offline_titulo, offline_msg: cadastro.offline_msg,
      };
      if (cadastro.id) await axios.put(`${API}/land/${cadastro.id}`, corpo);
      else await axios.post(`${API}/land`, corpo);
      ok('Land salva.');
      setCadastro(null);
      carregarLista();
    } catch (e) {
      erro(e.response?.data?.error || 'Não foi possível salvar.');
    } finally { setSalvandoCad(false); }
  }

  // ---------------- CONTEUDO (editor) ----------------
  async function abrirConteudo(id, modo) {
    try {
      const r = await axios.get(`${API}/land/${id}`);
      const lp = r.data;
      setPromptIa('');
      setEdit({
        id: lp.id, nome: lp.nome, slug: lp.slug, status: lp.status,
        html: lp.html || (modo === 'editor' ? HTML_EXEMPLO : ''), modo,
      });
    } catch (e) { erro('Não foi possível abrir o conteúdo.'); }
  }
  function fecharEditor() { setEdit(null); }

  async function salvarConteudo(publicar) {
    if (!edit.html || !edit.html.trim()) return erro('A land está sem conteúdo HTML.');
    setSalvando(true);
    try {
      await axios.put(`${API}/land/${edit.id}`, { html: edit.html, origem: edit.modo });
      if (publicar !== undefined) {
        await axios.put(`${API}/land/${edit.id}/status`, { ativa: publicar });
        setEdit((e) => ({ ...e, status: publicar ? 'publicada' : 'rascunho' }));
      }
      ok('Conteúdo salvo.');
      carregarLista();
    } catch (e) {
      erro(e.response?.data?.error || 'Não foi possível salvar.');
    } finally { setSalvando(false); }
  }

  async function excluir(id, nome) {
    const c = await Swal.fire({
      icon: 'warning', title: 'Excluir land?', text: `"${nome}" será removida.`,
      showCancelButton: true, confirmButtonText: 'Excluir', cancelButtonText: 'Cancelar',
      confirmButtonColor: '#d33', cancelButtonColor: '#888',
    });
    if (!c.isConfirmed) return;
    try {
      await axios.delete(`${API}/land/${id}`);
      ok('Removida.');
      if (edit?.id === id) fecharEditor();
      carregarLista();
    } catch (e) { erro(e.response?.data?.error || 'Não foi possível remover.'); }
  }

  async function toggleAtiva(lp) {
    try {
      await axios.put(`${API}/land/${lp.id}/status`, { ativa: lp.status !== 'publicada' });
      carregarLista();
      if (edit?.id === lp.id) setEdit((e) => ({ ...e, status: lp.status !== 'publicada' ? 'publicada' : 'rascunho' }));
    } catch (e) { erro(e.response?.data?.error || 'Não foi possível alterar.'); }
  }

  function copiarLink(slug) {
    const url = `${API}/publico/land/${slug}`;
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(url).then(() => ok('Link copiado!')).catch(() => mostrarLink(url));
    } else { mostrarLink(url); }
  }
  function mostrarLink(url) {
    Swal.fire({ title: 'Link público', html: `<code style="word-break:break-all">${url}</code>`, confirmButtonColor: ROXO });
  }

  // QR Code do link público (mesma função da Torcida — api.qrserver.com).
  function mostrarQr(slug, nome) {
    const url = `${API}/publico/land/${slug}`;
    Swal.fire({
      title: `QR Code${nome ? ' — ' + nome : ''}`,
      html: `<img src="${qrUrl(url)}" alt="QR Code" width="220" height="220" style="display:block;margin:0 auto 10px" />`
        + `<div style="word-break:break-all;font-size:.78rem;color:#666">${url}</div>`,
      confirmButtonText: 'Baixar QR',
      confirmButtonColor: ROXO,
      showCancelButton: true,
      cancelButtonText: 'Fechar',
    }).then((res) => { if (res.isConfirmed) window.open(`${qrUrl(url)}&download=1`, '_blank', 'noopener'); });
  }

  // ---- upload de arquivo (.html cai no editor / .zip vira site hospedado) ----
  async function aoEscolherArquivo(ev) {
    const f = ev.target.files?.[0];
    if (!f) return;
    const ehZip = /\.zip$/i.test(f.name);
    ev.target.value = '';
    if (!ehZip) {
      const reader = new FileReader();
      reader.onload = () => setEdit((e) => ({ ...e, html: String(reader.result || '') }));
      reader.readAsText(f);
      return;
    }
    setSalvando(true);
    try {
      const dataUrl = await new Promise((resolve, reject) => {
        const rd = new FileReader(); rd.onload = () => resolve(rd.result); rd.onerror = reject; rd.readAsDataURL(f);
      });
      const resp = await axios.post(`${API}/land/site-upload`, { id: edit.id, zip_base64: dataUrl });
      setEdit((e) => ({ ...e, html: resp.data.html }));
      ok('Site (.zip) enviado! Revise no preview e publique.');
      carregarLista();
    } catch (e) {
      erro(e.response?.data?.error || 'Não foi possível subir o .zip.');
    } finally { setSalvando(false); }
  }

  function aoEscolherImagem(ev) {
    const f = ev.target.files?.[0];
    if (!f) return;
    const reader = new FileReader();
    reader.onload = async () => {
      try {
        const r = await axios.post(`${API}/land/imagem`, { nome: f.name, dados_base64: reader.result });
        const url = `${API}${r.data.url}`;
        await Swal.fire({ icon: 'success', title: 'Imagem enviada', html: `Cole esta URL no seu HTML:<br><code style="word-break:break-all">${url}</code>`, confirmButtonColor: ROXO });
      } catch (e) { erro(e.response?.data?.error || 'Não foi possível enviar a imagem.'); }
    };
    reader.readAsDataURL(f);
    ev.target.value = '';
  }

  async function gerarIa() {
    if (!promptIa.trim()) return erro('Descreva a land que você quer gerar.');
    setGerandoIa(true);
    try {
      const r = await axios.post(`${API}/land/ia/gerar`, { prompt: promptIa });
      setEdit((e) => ({ ...e, html: r.data.html }));
      ok('HTML gerado! Revise no preview e salve.');
    } catch (e) {
      erro(e.response?.data?.error || 'A IA não respondeu.');
    } finally { setGerandoIa(false); }
  }

  // ---- config IA ----
  async function salvarConexao(provider, d) {
    await axios.put(`${API}/land/ia/config`, { provider, modelo: d.modelo, api_key: d.apiKey, ativo: d.ativo, temperatura: d.temperatura });
    ok('Conexão salva.');
    carregarConfig();
  }
  async function testarConexao(provider, d) {
    const r = await axios.post(`${API}/land/ia/testar`, { provider, modelo: d.modelo, api_key: d.apiKey, temperatura: d.temperatura });
    await Swal.fire({
      icon: 'success', title: 'Respondeu! ✅',
      html: `Modelo: <b>${r.data.modelo}</b><br>Tempo: <b>${r.data.ms} ms</b>${r.data.amostra ? `<br>Resposta: <code>${r.data.amostra}</code>` : ''}`,
      confirmButtonColor: ROXO,
    });
  }

  // ===================== RENDER =====================
  if (edit) {
    return (
      <EditorConteudo
        edit={edit} setEdit={setEdit} salvando={salvando} podeGerenciar={podeGerenciar}
        onVoltar={fecharEditor} onSalvar={salvarConteudo} onCopiarLink={copiarLink}
        promptIa={promptIa} setPromptIa={setPromptIa} gerandoIa={gerandoIa} onGerarIa={gerarIa}
        onArquivo={aoEscolherArquivo} onImagem={aoEscolherImagem}
      />
    );
  }

  return (
    <div className="container-fluid py-3" style={{ maxWidth: 1200 }}>
      <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
        <h3 className="mb-0" style={{ color: ROXO }}><i className="bi bi-window-stack me-2" />Land</h3>
        <ul className="nav nav-tabs flex-grow-1 justify-content-center" style={{ border: 'none' }}>
          <li className="nav-item"><button className={`nav-link ${aba === 'lista' ? 'active' : ''}`} onClick={() => setAba('lista')}>Lands</button></li>
          {podeGerenciar && <li className="nav-item"><button className={`nav-link ${aba === 'config' ? 'active' : ''}`} onClick={() => setAba('config')}>Configurar IA</button></li>}
        </ul>
        {aba === 'lista' && podeGerenciar && (
          <button className="btn" style={{ background: ROXO, color: '#fff' }} onClick={novaLand}>
            <i className="bi bi-plus-lg me-1" />Nova land
          </button>
        )}
      </div>

      {aba === 'lista' && (
        <TabelaLands
          lista={lista} carregando={carregando} podeGerenciar={podeGerenciar}
          onSubir={(id) => abrirConteudo(id, 'upload')} onEditor={(id) => abrirConteudo(id, 'editor')} onIa={(id) => abrirConteudo(id, 'ia')}
          onEditarDados={editarDados} onToggle={toggleAtiva} onCopiarLink={copiarLink} onQr={mostrarQr} onExcluir={excluir}
        />
      )}

      {aba === 'config' && podeGerenciar && (
        <ConexaoIa configIa={configIa} onSalvar={salvarConexao} onTestar={testarConexao} />
      )}

      {cadastro && (
        <CadastroModal
          cadastro={cadastro} setCadastro={setCadastro} salvando={salvandoCad}
          onSalvar={salvarCadastro} onFechar={() => setCadastro(null)}
        />
      )}
    </div>
  );
}

// ---------------------------------------------------------------------------
function TabelaLands({ lista, carregando, podeGerenciar, onSubir, onEditor, onIa, onEditarDados, onToggle, onCopiarLink, onQr, onExcluir }) {
  if (carregando) return <div className="text-center py-5"><div className="spinner-border" style={{ color: ROXO }} /></div>;
  if (!lista.length) return <div className="text-center text-muted py-5"><i className="bi bi-window-stack fs-1 d-block mb-2" />Nenhuma land cadastrada. Clique em “Nova land” para começar.</div>;
  return (
    <div className="table-responsive">
      <table className="table align-middle">
        <thead><tr className="text-muted small">
          <th>Nome</th><th>Link</th><th>Prazo</th><th className="text-center">Ativa</th><th>Conteúdo</th><th className="text-end">Ações</th>
        </tr></thead>
        <tbody>
          {lista.map((lp) => {
            const ativa = lp.status === 'publicada';
            return (
              <tr key={lp.id}>
                <td><strong>{lp.nome}</strong></td>
                <td>
                  <button className="btn btn-sm btn-link p-0 text-decoration-none" onClick={() => onCopiarLink(lp.slug)} title="Copiar link público">
                    <i className="bi bi-link-45deg" /> /{lp.slug}
                  </button>
                </td>
                <td className="small">{fmtPrazo(lp.data_inicio, lp.data_fim)}</td>
                <td className="text-center">
                  {podeGerenciar ? (
                    <div className="form-check form-switch d-inline-block" title={ativa ? 'Ativa — clique para desativar' : 'Inativa — clique para ativar'}>
                      <input className="form-check-input" type="checkbox" role="switch" checked={ativa} onChange={() => onToggle(lp)} style={ativa ? { background: ROXO, borderColor: ROXO } : {}} />
                    </div>
                  ) : (
                    <span className={`badge bg-${ativa ? 'success' : 'secondary'}`}>{ativa ? 'Ativa' : 'Inativa'}</span>
                  )}
                </td>
                <td>{lp.tem_html ? <span className="badge bg-light text-dark border">{ORIGEM_LABEL[lp.origem] || lp.origem}</span> : <span className="text-muted small">— vazio —</span>}</td>
                <td className="text-end text-nowrap">
                  {podeGerenciar && (
                    <div className="btn-group btn-group-sm me-2" role="group" title="Produzir conteúdo">
                      <button className="btn btn-outline-secondary" onClick={() => onSubir(lp.id)} title="Subir HTML/ZIP"><i className="bi bi-upload" /></button>
                      <button className="btn btn-outline-secondary" onClick={() => onEditor(lp.id)} title="Editor"><i className="bi bi-code-slash" /></button>
                      <button className="btn btn-outline-secondary" onClick={() => onIa(lp.id)} title="Criar com IA"><i className="bi bi-stars" /></button>
                    </div>
                  )}
                  {!podeGerenciar && (
                    <button className="btn btn-sm btn-outline-secondary me-1" onClick={() => onEditor(lp.id)} title="Ver conteúdo"><i className="bi bi-eye" /></button>
                  )}
                  <button className="btn btn-sm btn-outline-secondary me-1" onClick={() => onQr(lp.slug, lp.nome)} title="QR Code do link"><i className="bi bi-qr-code" /></button>
                  {ativa && (
                    <a className="btn btn-sm btn-outline-secondary me-1" href={`${API}/publico/land/${lp.slug}`} target="_blank" rel="noreferrer" title="Abrir página pública"><i className="bi bi-box-arrow-up-right" /></a>
                  )}
                  {podeGerenciar && <button className="btn btn-sm btn-outline-primary me-1" onClick={() => onEditarDados(lp.id)} title="Editar dados"><i className="bi bi-pencil" /></button>}
                  {podeGerenciar && <button className="btn btn-sm btn-outline-danger" onClick={() => onExcluir(lp.id, lp.nome)} title="Excluir"><i className="bi bi-trash" /></button>}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

// ---------------------------------------------------------------------------
function CadastroModal({ cadastro, setCadastro, salvando, onSalvar, onFechar }) {
  const set = (campo) => (e) => setCadastro((p) => ({ ...p, [campo]: e.target.value }));
  return (
    <div onClick={onFechar} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 1050, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', padding: 16, overflowY: 'auto' }}>
      <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-3 p-4 mt-4" style={{ maxWidth: 640, width: '100%' }}>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h5 className="mb-0" style={{ color: ROXO }}>{cadastro.id ? 'Editar dados da land' : 'Nova land'}</h5>
          <button className="btn-close" onClick={onFechar} />
        </div>

        <div className="mb-3">
          <label className="form-label small fw-bold">Nome da campanha *</label>
          <input className="form-control" value={cadastro.nome} onChange={set('nome')} placeholder="Ex: Liquida Construção Junho" autoFocus />
        </div>

        <div className="mb-3">
          <label className="form-label small fw-bold">Link <span className="text-muted fw-normal">(opcional — gerado a partir do nome se vazio)</span></label>
          <div className="input-group">
            <span className="input-group-text text-muted" style={{ maxWidth: '55%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: 12 }}>{API}/publico/land/</span>
            <input className="form-control" value={cadastro.slug} onChange={set('slug')} placeholder="liquida-construcao-junho" />
          </div>
        </div>

        <div className="row g-3 mb-3">
          <div className="col-md-6">
            <label className="form-label small fw-bold">No ar a partir de <span className="text-muted fw-normal">(opcional)</span></label>
            <input type="datetime-local" className="form-control" value={cadastro.data_inicio} onChange={set('data_inicio')} />
          </div>
          <div className="col-md-6">
            <label className="form-label small fw-bold">No ar até <span className="text-muted fw-normal">(opcional)</span></label>
            <input type="datetime-local" className="form-control" value={cadastro.data_fim} onChange={set('data_fim')} />
          </div>
        </div>

        <div className="form-check form-switch mb-3">
          <input className="form-check-input" type="checkbox" role="switch" id="land-ativa" checked={cadastro.ativa} onChange={(e) => setCadastro((p) => ({ ...p, ativa: e.target.checked }))} style={cadastro.ativa ? { background: ROXO, borderColor: ROXO } : {}} />
          <label className="form-check-label" htmlFor="land-ativa">Ativa <span className="text-muted small">(o link público fica no ar — precisa ter conteúdo e estar dentro do prazo)</span></label>
        </div>

        <div className="border-top pt-3 mb-3">
          <label className="form-label small fw-bold mb-2"><i className="bi bi-sign-stop me-1" />Página “fora do ar” <span className="text-muted fw-normal">(exibida quando o link é acessado e a campanha não está no ar)</span></label>
          <input className="form-control form-control-sm mb-2" value={cadastro.offline_titulo} onChange={set('offline_titulo')} placeholder="Título — ex: Em breve!" maxLength={200} />
          <input className="form-control form-control-sm" value={cadastro.offline_msg} onChange={set('offline_msg')} placeholder="Mensagem — ex: Nossa campanha começa dia 01/07. Volte logo!" maxLength={500} />
        </div>

        <div className="d-flex justify-content-end gap-2">
          <button className="btn btn-outline-secondary" onClick={onFechar}>Cancelar</button>
          <button className="btn" style={{ background: ROXO, color: '#fff' }} disabled={salvando} onClick={onSalvar}>
            {salvando ? <><span className="spinner-border spinner-border-sm me-1" />Salvando…</> : <><i className="bi bi-save me-1" />Salvar</>}
          </button>
        </div>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------------
function EditorConteudo({ edit, setEdit, salvando, podeGerenciar, onVoltar, onSalvar, onCopiarLink, promptIa, setPromptIa, gerandoIa, onGerarIa, onArquivo, onImagem }) {
  const soLeitura = !podeGerenciar;
  const ativa = edit.status === 'publicada';
  const setModo = (m) => setEdit((e) => ({ ...e, modo: m }));

  return (
    <div className="container-fluid py-3" style={{ maxWidth: 1300 }}>
      <div className="d-flex align-items-center justify-content-between mb-2 flex-wrap gap-2">
        <div className="d-flex align-items-center gap-2">
          <button className="btn btn-outline-secondary btn-sm" onClick={onVoltar}><i className="bi bi-arrow-left" /> Voltar</button>
          <h5 className="mb-0" style={{ color: ROXO }}>{edit.nome}</h5>
          <span className={`badge bg-${ativa ? 'success' : 'secondary'}`}>{ativa ? 'Ativa' : 'Inativa'}</span>
        </div>
        {!soLeitura && (
          <div className="d-flex gap-2 flex-wrap">
            <button className="btn btn-outline-primary btn-sm" disabled={salvando} onClick={() => onSalvar(undefined)}><i className="bi bi-save me-1" />Salvar conteúdo</button>
            {ativa
              ? <button className="btn btn-outline-warning btn-sm" disabled={salvando} onClick={() => onSalvar(false)}><i className="bi bi-eye-slash me-1" />Desativar</button>
              : <button className="btn btn-sm" style={{ background: ROXO, color: '#fff' }} disabled={salvando} onClick={() => onSalvar(true)}><i className="bi bi-broadcast me-1" />Salvar e ativar</button>}
            <button className="btn btn-outline-secondary btn-sm" onClick={() => onCopiarLink(edit.slug)}><i className="bi bi-link-45deg me-1" />Copiar link</button>
            {ativa && <a className="btn btn-outline-secondary btn-sm" href={`${API}/publico/land/${edit.slug}`} target="_blank" rel="noreferrer"><i className="bi bi-box-arrow-up-right me-1" />Abrir</a>}
          </div>
        )}
      </div>

      {/* Switch de modo de produção do conteúdo */}
      {!soLeitura && (
        <div className="btn-group btn-group-sm mb-2" role="group">
          {['upload', 'editor', 'ia'].map((m) => (
            <button key={m} className={`btn ${edit.modo === m ? '' : 'btn-outline-secondary'}`}
              style={edit.modo === m ? { background: ROXO, color: '#fff', borderColor: ROXO } : {}} onClick={() => setModo(m)}>
              <i className={`bi ${m === 'upload' ? 'bi-upload' : m === 'editor' ? 'bi-code-slash' : 'bi-stars'} me-1`} />{MODO_LABEL[m]}
            </button>
          ))}
        </div>
      )}

      {/* Entrada específica do modo */}
      {!soLeitura && edit.modo === 'upload' && (
        <div className="alert alert-light border d-flex align-items-center gap-2 flex-wrap py-2">
          <i className="bi bi-upload" />
          <label className={`btn btn-sm btn-outline-secondary mb-0 ${salvando ? 'disabled' : ''}`}>
            Escolher arquivo (.html ou .zip)<input type="file" accept=".html,.htm,.zip,text/html,application/zip" hidden disabled={salvando} onChange={onArquivo} />
          </label>
          <span className="small text-muted"><b>.html</b> cai no editor. <b>.zip</b> (HTML + imagens + CSS/JS) é hospedado e os assets passam a funcionar pela página pública. Máx. 25 MB.</span>
        </div>
      )}
      {!soLeitura && edit.modo === 'ia' && (
        <div className="alert alert-light border py-2">
          <label className="form-label small fw-bold"><i className="bi bi-stars me-1" />Descreva a land para a IA</label>
          <textarea className="form-control mb-2" rows={2} value={promptIa} onChange={(e) => setPromptIa(e.target.value)}
            placeholder="Ex: Land da campanha 'Liquida Construção' do Centrão, hero roxo, destaque pra cimento, tinta e porcelanato, botão de WhatsApp e selo de frete grátis acima de R$ 500." />
          <button className="btn btn-sm" style={{ background: ROXO, color: '#fff' }} disabled={gerandoIa} onClick={onGerarIa}>
            {gerandoIa ? <><span className="spinner-border spinner-border-sm me-1" />Gerando…</> : <><i className="bi bi-magic me-1" />Gerar HTML</>}
          </button>
          <span className="small text-muted ms-2">Usa o provedor ativo na aba “Configurar IA”.</span>
        </div>
      )}

      {/* Editor + preview */}
      <div className="row g-3">
        <div className="col-lg-6">
          <div className="d-flex justify-content-between align-items-center mb-1">
            <label className="form-label small fw-bold mb-0">HTML</label>
            {!soLeitura && (
              <label className="btn btn-sm btn-outline-secondary mb-0 py-0">
                <i className="bi bi-image me-1" />Enviar imagem<input type="file" accept="image/*" hidden onChange={onImagem} />
              </label>
            )}
          </div>
          <textarea className="form-control font-monospace" style={{ height: '62vh', fontSize: 13 }}
            value={edit.html} onChange={(e) => setEdit((p) => ({ ...p, html: e.target.value }))} disabled={soLeitura} spellCheck={false}
            placeholder="Cole ou escreva o HTML aqui…" />
        </div>
        <div className="col-lg-6">
          <label className="form-label small fw-bold mb-1">Preview <span className="text-muted fw-normal">(sem JavaScript — só layout; o JS roda na página publicada)</span></label>
          <iframe title="preview" srcDoc={edit.html} sandbox="allow-same-origin"
            style={{ width: '100%', height: '62vh', border: '1px solid #ddd', borderRadius: 6, background: '#fff' }} />
        </div>
      </div>
    </div>
  );
}

// ---------------------------------------------------------------------------
// Painel único: escolhe provedor → modelo → chave → ativa → criatividade. Salvar + Testar.
// Ao lado, o tutorial de como pegar a chave do provedor selecionado.
function ConexaoIa({ configIa, onSalvar, onTestar }) {
  const [provider, setProvider] = useState('anthropic');
  const [form, setForm] = useState({ modelo: '', apiKey: '', ativo: false, temperatura: 0.7, custom: false });
  const [salvando, setSalvando] = useState(false);
  const [testando, setTestando] = useState(false);
  const initRef = useRef(false);

  const meta = metaProvider(provider);
  const atual = configIa.find((c) => c.provider === provider) || {};

  // Na primeira carga, seleciona o provedor que já está ativo.
  useEffect(() => {
    if (!initRef.current && configIa.length) {
      const at = configIa.find((c) => c.ativo);
      if (at) setProvider(at.provider);
      initRef.current = true;
    }
  }, [configIa]);

  // Carrega o form com o que está salvo para o provedor selecionado.
  useEffect(() => {
    const cfg = configIa.find((c) => c.provider === provider) || {};
    const m = metaProvider(provider);
    const modeloSalvo = cfg.modelo || (m.modelos[0] && m.modelos[0].id) || '';
    const naLista = m.modelos.some((x) => x.id === modeloSalvo);
    setForm({
      modelo: modeloSalvo,
      apiKey: '',
      ativo: !!cfg.ativo,
      temperatura: cfg.temperatura != null ? Number(cfg.temperatura) : 0.7,
      custom: !!modeloSalvo && !naLista,
    });
  }, [provider, configIa]);

  const setF = (campo, val) => setForm((f) => ({ ...f, [campo]: val }));
  const dados = () => ({ modelo: form.modelo.trim(), apiKey: form.apiKey, ativo: form.ativo, temperatura: form.temperatura });

  const validar = () => {
    if (!form.modelo.trim()) { Swal.fire({ icon: 'warning', title: 'Escolha um modelo', confirmButtonColor: ROXO }); return false; }
    if (!atual.tem_chave && !form.apiKey.trim()) { Swal.fire({ icon: 'warning', title: 'Informe a chave da API', confirmButtonColor: ROXO }); return false; }
    return true;
  };
  const salvar = async () => {
    if (!validar()) return;
    setSalvando(true);
    try { await onSalvar(provider, dados()); }
    catch (e) { Swal.fire({ icon: 'error', title: 'Ops', text: e.response?.data?.error || 'Não foi possível salvar.', confirmButtonColor: ROXO }); }
    finally { setSalvando(false); }
  };
  const testar = async () => {
    if (!form.modelo.trim()) { Swal.fire({ icon: 'warning', title: 'Escolha um modelo', confirmButtonColor: ROXO }); return; }
    setTestando(true);
    try { await onTestar(provider, dados()); }
    catch (e) { Swal.fire({ icon: 'error', title: 'O provedor não respondeu', text: e.response?.data?.error || 'Erro ao testar.', confirmButtonColor: ROXO }); }
    finally { setTestando(false); }
  };

  const selValue = form.custom ? '__outro__' : form.modelo;
  const onModelo = (v) => { if (v === '__outro__') setF('custom', true); else setForm((f) => ({ ...f, custom: false, modelo: v })); };

  return (
    <div className="row g-4">
      {/* FORM */}
      <div className="col-lg-7">
        <div className="card">
          <div className="card-body">
            <h6 className="fw-bold mb-1" style={{ color: ROXO }}><i className="bi bi-robot me-1" />Conexão da IA</h6>
            {atual.tem_chave
              ? <div className="small text-success mb-3"><i className="bi bi-check-circle me-1" />Chave configurada ({atual.chave_mascara || '••••'}) {atual.ativo && <span className="badge ms-1" style={{ background: ROXO }}>ativa</span>}</div>
              : <div className="small text-muted mb-3"><i className="bi bi-exclamation-circle me-1" />Nenhuma chave salva para este provedor ainda.</div>}

            <label className="form-label small fw-bold mb-1">Provedor</label>
            <select className="form-select mb-3" value={provider} onChange={(e) => setProvider(e.target.value)}>
              {PROVIDERS_META.map((m) => <option key={m.key} value={m.key}>{m.nome} — {m.plano}</option>)}
            </select>

            <label className="form-label small fw-bold mb-1">Modelo</label>
            <select className="form-select mb-2" value={selValue} onChange={(e) => onModelo(e.target.value)}>
              {meta.modelos.map((m) => <option key={m.id} value={m.id}>{m.label}</option>)}
              <option value="__outro__">Outro (digitar)…</option>
            </select>
            {form.custom && (
              <input className="form-control mb-2" value={form.modelo} onChange={(e) => setF('modelo', e.target.value)} placeholder="ID do modelo (ex: claude-sonnet-4-6)" />
            )}

            <div className="form-check form-switch mb-3 mt-1">
              <input className="form-check-input" type="checkbox" role="switch" id="ia-ativa" checked={form.ativo} onChange={(e) => setF('ativo', e.target.checked)} style={form.ativo ? { background: ROXO, borderColor: ROXO } : {}} />
              <label className="form-check-label" htmlFor="ia-ativa">IA ativa <span className="text-muted small">(usa este provedor ao “Criar com IA” — só um fica ativo)</span></label>
            </div>

            <label className="form-label small fw-bold mb-1">Chave da API {atual.tem_chave && <span className="badge bg-success ms-1">salva</span>}</label>
            <input type="password" className="form-control mb-3" value={form.apiKey} onChange={(e) => setF('apiKey', e.target.value)}
              placeholder={atual.tem_chave ? '•••• (deixe em branco para manter)' : meta.chaveDica} autoComplete="off" />

            <label className="form-label small fw-bold mb-1">Criatividade ({Number(form.temperatura).toFixed(1)})</label>
            <input type="range" className="form-range" min="0" max="1" step="0.1" value={form.temperatura} onChange={(e) => setF('temperatura', Number(e.target.value))} />
            <div className="d-flex justify-content-between text-muted" style={{ fontSize: '.72rem' }}>
              <span>0 — mais consistente</span><span>1 — mais criativa</span>
            </div>

            <div className="d-flex gap-2 flex-wrap mt-3">
              <button className="btn" style={{ background: ROXO, color: '#fff' }} disabled={salvando} onClick={salvar}>
                {salvando ? <><span className="spinner-border spinner-border-sm me-1" />Salvando…</> : <><i className="bi bi-save me-1" />Salvar conexão</>}
              </button>
              <button className="btn btn-outline-success" disabled={testando} onClick={testar}>
                {testando ? <><span className="spinner-border spinner-border-sm me-1" />Testando…</> : <><i className="bi bi-plug me-1" />Testar</>}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* TUTORIAL */}
      <div className="col-lg-5">
        <div className="card h-100" style={{ background: '#F5EBF2', border: 'none' }}>
          <div className="card-body">
            <h6 className="fw-bold mb-1" style={{ color: ROXO }}>
              <i className="bi bi-info-circle me-1" />Como pegar a chave — {meta.nome}
            </h6>
            <span className={`badge mb-3 ${meta.plano === 'Gratuito' ? 'bg-success' : 'bg-secondary'}`}>{meta.plano}</span>
            <ol className="small ps-3 mb-3">
              {meta.tutorial.map((passo, i) => <li key={i} className="mb-1">{passo}</li>)}
            </ol>
            <a className="btn btn-sm w-100 mb-3" style={{ background: ROXO, color: '#fff' }} href={meta.console} target="_blank" rel="noopener noreferrer">
              <i className="bi bi-box-arrow-up-right me-1" />{meta.consoleLabel}
            </a>
            {meta.recomendacao && (
              <div className="small p-2 rounded" style={{ background: '#fff', borderLeft: `3px solid ${ROXO}` }}>
                <i className="bi bi-lightbulb me-1" style={{ color: ROXO }} />{meta.recomendacao}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
